var scope_0 = require('/home/travis/build/logrinto/IAD2017.thesis/sites/example/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/home/travis/build/logrinto/IAD2017.thesis/sites/example/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6de8391fd4cac9404a8cdd888af99257.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    